<template>
  <v-card width="375" flat class="swift-details mx-auto">
    <back-button v-if="!singlePaymentMethod" @click="$emit('abort')"/>
    <p class="pageTitle">{{$t('swift_transfer')}}</p>
    <p class="pageSubtitle mt-n1 mb-0 mr-n2" >{{$t('details_swift_title')}}</p>
    <p class="pageSubtitle" >{{$t('details_swift_title_2')}}</p>
    
    <div ref="pdfElement" class="print-borderaround">
      <div class="result-table">
        <div class="d-flex divider">
          <div class="formLabel mt-n1">{{$t('iban')}}</div>
          <copyable :label="account.iban"/>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('bic')}}</div>
          <copyable :label="account.bic"/>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('beneficiary')}}</div>
          <copyable :label="account.beneficiary"/>
        </div>
        <div class="d-flex divider">
          <div>
            <div class="formLabel">{{$t('motive_transfer')}}</div>
            <span class="formLabel printFormLabel">({{$t('motive_proposition')}})</span></div>
          <copyable :label="account.motif"/>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('payment_currency')}}</div>
          <div class="formValue">{{account.currency}}</div>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('transfer_type')}}</div>
          <div class="formValue">{{account.transferType}}</div>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('fees_repartition')}}</div>
          <div class="formValue">{{account.fees}}</div>
        </div>
      </div>
      
      <pdf-maker :printData="printData" :filePrefix="'swift_details_'" class="hideWhenPrinting mt-6"/>
      
      <check-box
        class="paymentDetailsCheckbox hideWhenPrinting"
        v-model="conditionChecked"
        :label="$t('accept_saving_of_bank_info')">
      </check-box>
    </div>

    <v-card-actions class="pa-0">
      <ConfirmButton 
        :disabled="!conditionChecked"
        @click="confirm"
        class="icon-button">
        {{$t('confirm')}}
        <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
      </ConfirmButton>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { VCard, VCardActions } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import BackButton from '@/components/BackButton'
  import CheckBox from '@/components/CheckBox'
  import Copyable from '@/components/Copyable'
  import PdfMaker from '@/components/PdfMaker'
  import {mapState} from 'vuex'

  export default {
    name: 'PaymentDetailSWIFT',
    components: { VCard, VCardActions, BackButton, ConfirmButton, PdfMaker, Copyable, CheckBox },
    props: {
      params: {
        type: Object,
        default: () => {}
      }
    },
    mounted: function () {
      this.printData = this.getPrintData()
    },
    methods: {
      confirm: function () {
        this.$emit('confirm', {})
      },
      getPrintData: function () {
        return [
          { text: this.$t('print_sct_title'), class: 'print-title' },
          { text: this.$t('print_swift_title2'), class: 'print-title mb-25' },
          { text: this.$t('print_swift_info'), class: 'print-description' },
          { text: this.$t('print_sct_info2'), class: 'print-description' },
          { element: this.$refs.pdfElement }
        ]
      }
    },
    computed: {
      ...mapState(['singlePaymentMethod']),
      account: function () {
        let transactionData = (this.params && this.params.transactionData) ? this.params.transactionData : {}
        let marketPlaceName = (transactionData && transactionData.payee && transactionData.payee.thirdPartyName) ? transactionData.payee.thirdPartyName : null
        let orderRef = transactionData.orderRef || ((this.params && this.params.mkpData) ? this.params.mkpData.orderRef : '')
        return {
          iban: transactionData.virtualIban || '',
          bic: 'AGRIFRPP',
          beneficiary: marketPlaceName || '',
          motif: (marketPlaceName ? marketPlaceName + ' - ' : '') + orderRef,
          currency: (this.params && this.params.mkpData) ? this.params.mkpData.currencyCode : '',
          transferType: this.$t('commercial'),
          fees: this.$t('our')
        }
      }
    },
    data: function () {
      return {
        conditionChecked: false,
        printData: null
      }
    }
  }
</script>